import React from 'react';
import {Trans} from 'react-i18next';
import {connect} from "react-redux";
import TipsAndTricks from "../../../../../../../../../../components/tips-and-tricks/index";
import {guidedTours} from "../../../../../../../../../../../actions/guidedToursActions";

class T1 extends React.Component {

    constructor(props){
        super(props);

        this.closeHandler = this.closeHandler.bind(this);
    }

    t1 = null;

    componentDidMount(){
        if(this.props.isLabelsLoading === false){
            setTimeout(() => {
                this.position();

                window.addEventListener('resize', () => {
                    this.position()
                });
            }, 1000);
        }
    }

    closeHandler(){
        this.t1.style.transform = "scale(0)";
        this.props.setGuidedTours({
            "t1" : true
        });
    }

    position(){

        if(document.querySelector(".list-of-contacts-body-content .contact") && document.getElementById("t1")){

            let targetCoord = document.querySelector(".list-of-contacts-body-content .contact").getBoundingClientRect();
            this.t1 = document.getElementById("t1");

            /*
            * t3.offsetWidth instead of document.getElementById("t3").getBoundingClientRect().width to keep the initial width and not the one calculated by the scale effect.
            * */

            this.t1.style.left = (targetCoord.x - this.t1.offsetWidth - 10 ) + "px";
            this.t1.style.top = targetCoord.y - 10 + "px";

            setTimeout(() => {
                this.t1.style.transform = "scale(1)";
            },500);
        }

    }

    render() {
        return (
            <TipsAndTricks id="t1" dir="right" onClose={this.closeHandler}>
                <Trans i18nKey="textTipsAndTricks" components={{icon: <svg width="24" className="mx-1" version="1.1" viewBox="0 0 24 24">
                    <path fill="#0297a7" d="M12,0.8c6.2,0,11.3,5,11.3,11.3s-5,11.3-11.3,11.3S0.8,18.2,0.8,12S5.8,0.8,12,0.8 M12,0C5.4,0,0,5.4,0,12 s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0L12,0z"/>
                    <line fill="none" stroke="#0297a7" strokeWidth="0.75" strokeMiterlimit="10" x1="8.6" y1="12.8" x2="13.5" y2="15.2"/>
                    <line fill="none" stroke="#0297a7" strokeWidth="0.75" strokeMiterlimit="10" x1="8.6" y1="10.9" x2="13.5" y2="8.5"/>
                    <circle fill="#0297a7" cx="15.4" cy="7.5" r="2.2"/>
                    <circle fill="#0297a7" cx="15.4" cy="16.2" r="2.2"/>
                    <circle fill="#0297a7" cx="6.7" cy="11.9" r="2.2"/>
                </svg> }} />
            </TipsAndTricks>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLabelsLoading : state.contactsGroupItemReducer.isLabelsLoading,
        profile : state.profileReducer.getProfile
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setGuidedTours : (object) => {
            dispatch(guidedTours(object))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(T1);